import * as React from 'react';

import { PageTitleBar } from 'components';

const RoleHeader = ({ children }: React.PropsWithChildren<unknown>) => (
  <PageTitleBar headerTitle={children} />
);

export { RoleHeader };
